export type StudentReadiness = {
  profile_complete: boolean;
  has_identity: boolean;
  has_registrant_data: boolean;
  registrant_type?: string;
  missing?: string[];
  message: string;
};

/** API payload for a self-student who registered with name + sex only. */
export const SELF_STUDENT_WITHOUT_SURNAME_DOB: StudentReadiness = {
  profile_complete: true,
  has_identity: true,
  has_registrant_data: true,
  registrant_type: 'self',
  missing: [],
  message: 'Профиль готов к созданию заявок и модерации.',
};

export const PARENT_STUDENT_WITHOUT_CHILDREN: StudentReadiness = {
  profile_complete: true,
  has_identity: true,
  has_registrant_data: true,
  registrant_type: 'parent',
  missing: [],
  message: 'Профиль готов к созданию заявок и модерации.',
};

/**
 * Cabinet nag for role student (id 2).
 * Surname, patronymic and date_of_birth are never required for the student.
 * Parent path does not collect children - only the bulletin mark "Для ребенка".
 */
export function isStudentCompletionNagShown(
  data: StudentReadiness | undefined,
): data is StudentReadiness {
  return data != null && data.profile_complete === false;
}

export function studentCompletionNagItems(data: StudentReadiness): string[] {
  if (!isStudentCompletionNagShown(data)) {
    return [];
  }

  const items: string[] = [];
  if (data.missing?.includes('identity') || !data.has_identity) {
    items.push('Укажи имя');
  }
  if (data.missing?.includes('self_data') || !data.has_registrant_data) {
    items.push('Укажи пол');
  }
  return items;
}

const _selfStudentNagProof = studentCompletionNagItems(SELF_STUDENT_WITHOUT_SURNAME_DOB);
if (
  isStudentCompletionNagShown(SELF_STUDENT_WITHOUT_SURNAME_DOB) ||
  _selfStudentNagProof.length > 0
) {
  throw new Error(
    'Student cabinet must not nag for missing surname or date of birth',
  );
}

const _parentStudentNagProof = studentCompletionNagItems(PARENT_STUDENT_WITHOUT_CHILDREN);
if (
  isStudentCompletionNagShown(PARENT_STUDENT_WITHOUT_CHILDREN) ||
  _parentStudentNagProof.length > 0
) {
  throw new Error('Student cabinet must not nag parent to add children');
}
